import React, {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {deliverTest, getAssembledQuizByName} from "../../services/API";
import {ProgressBar} from "../../components/ProgressBar";
import {Question} from "./Question";
import {ImageQuestion} from "./ImageQuestion";
import useAlert from "../../hooks/useAlert";
import {ERROR_TYPE} from "../../contexts/AlertContext";
import Header from "../../components/navigation/Header";
import {getInterpolatedColor, score_palette} from "../../components/color/Palettes";
import {TagGroupDisplay} from "../../components/quiz/TagGroupDisplay";
import {FaTasks} from "react-icons/fa";
import {MdAccessTime} from "react-icons/md";
import {useError} from "../../hooks/useError";
import ImageContent from "../course/ImageContent";
import {IoPlayForward} from "react-icons/io5";


export default function Quiz() {

    const [quiz, setQuiz] = useState(null);
    const [start, setStart] = useState(false);
    const params = useParams();
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    let currentAnswers = [];
    const [testAnswers, setTestAnswers] = useState([]);
    const {setAlert} = useAlert();
    const {setErrorMessage} = useError();
    const {courseId} = useOutletContext();

    const TEXT_QUESTION = "TEXT_QUESTION";
    const IMAGE_QUESTION = "IMAGE_QUESTION";

    useEffect(() => {
        if (quiz == null) {
            getAssembledQuizByName(params.quizName, setErrorMessage).then(result => {
                setQuiz(result);
                console.log(result)
            }).catch(error => setAlert(ERROR_TYPE, error.message));
        }
    }, [quiz])


    function nextQuestion() {

        let copy = [];

        for (let i = 0; i < currentAnswers.length; i++) {
            copy.push(currentAnswers[i]);
        }

        setTestAnswers([...testAnswers, {
            question: quiz.questions[page],
            answers: copy
        }])
        if (page < quiz.questions.length - 1) {
            setPage(page + 1);
            currentAnswers = []
        } else {
            completeTest()
        }
    }

    function selectOption(option) {

        if (currentAnswers.includes(option) && quiz.questions[page].multipleChoice) {
            let copy = [...currentAnswers]
            currentAnswers = copy.splice(copy.indexOf(option), 1)
        } else {
            currentAnswers.push(option)
        }
    }

    function renderQuestion(index) {

        if (start) {
            let question = quiz.questions[index];

            if (question.questionType === TEXT_QUESTION) {
                return (<Question test={quiz} question={question} nextQuestionCallback={nextQuestion}
                                  selectOptionCallback={selectOption}/>)
            } else if (question.questionType === IMAGE_QUESTION) {
                return (<ImageQuestion question={question} nextQuestionCallback={nextQuestion}
                                       selectOptionCallback={selectOption}/>)
            }
        }


        return null;

    }

    function completeTest(redirect = true) {
        deliverTest(courseId, quiz.testId, testAnswers, setErrorMessage).then(result => {
            navigate("result/" + result);
        })

    }

    if (quiz != null) {
        return (

            <>
                <Header></Header>
                <div className={" bg-white h-100 d-flex flex-column justify-content-start pt-5 w-100"}
                     style={{minHeight: "100vh"}}>

                    <div className={"container d-flex justify-content-center align-items-start w-100"}>
                        <div className={" bg-white  d-flex p-0 flex-column justify-content-start  w-100"}>

                            {
                                start ?
                                    <>


                                        {renderQuestion(page)}
                                        <div className={"px-4"}>
                                            <ProgressBar progress={(page / quiz.questions.length) * 100} height={15}
                                                         show={false}/>
                                        </div>
                                    </>
                                    :
                                    <div
                                        className={"d-flex flex-column justify-content-start align-items-center w-100 "}>

                                        <div className={"container p-5"} style={{maxWidth: "50vw"}}>
                                            <div className={"row "}>
                                                <div className={"col"}>
                                                    <h1>{quiz.name}</h1>

                                                    <div className={"row my-2"}>
                                                        <div className={"col d-flex align-items-center "}>
                                                            <FaTasks size={18} className={"me-2"}/>
                                                            <label
                                                                className={"fs-5"}>{quiz.questions.length} oppgaver</label>
                                                        </div>
                                                        <div
                                                            className={"col d-flex align-items-center justify-content-end"}>
                                                            <MdAccessTime size={18} className={"me-2"}/>
                                                            <label
                                                                className={"fs-5"}> {Math.round(quiz.questions.length * 10 / 60)} min</label>
                                                        </div>

                                                    </div>

                                                    {
                                                        quiz.image != null ?
                                                            <ImageContent className={"w-50"} format={quiz.image.format}
                                                                          url={quiz.image.url}/> : null
                                                    }

                                                    <h5>Temaer</h5>
                                                    <TagGroupDisplay tags={quiz.tags}/>

                                                    <button
                                                        className={"btn btn-dark text-white mt-5 w-100 py-3 rounded-5 d-flex justify-content-center "}
                                                        onClick={() => setStart(true)}>
                                                        <IoPlayForward size={24} className={"me-3"}/>
                                                        <label>Start quiz</label>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }

}
